import PropTypes from 'prop-types'
import { Icon } from '../icon'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'

/** designed to render a hyperlink that opens in a new browser tab  */
const NewTabLink = ({ url, children }) => (
  <a
    href={url}
    target='_blank'
    rel='noopener noreferrer'
    className='d-inline-block text-start'
  >
    {children} <span className='sr-only'>(opens in new window)</span>
    <span aria-hidden='true'>
      <Icon icon={faExternalLinkAlt} size='lg' />
    </span>
  </a>
)

NewTabLink.propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export { NewTabLink }
